import { gotoSignedInApp, useValidateUserData } from '@amagimedia/commons';
import { FunctionComponent } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

export const VerifiedLoginRoute: FunctionComponent<RouteProps> = (props) => {
  const loginData = useValidateUserData();

  if (
    loginData &&
    loginData.role !== 'amagi_operator_admin' &&
    loginData.role !== 'amagi_sales_admin'
  ) {
    const subDomain = window.location.host.split('.')[0];
    if (subDomain && subDomain === loginData.account_domain) {
      return <Redirect to="/now" />;
    }
  }

  if (loginData) {
    gotoSignedInApp(loginData);
    return null;
  }

  return <Route {...props} />;
};
